import React, { useState } from 'react';
import { array, number, string } from 'prop-types';
import useStyles from 'hooks/useStyles';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import Button from 'components/Button';
import { sendGTMEvent } from 'reduxModules/googleTagManager/action';
import CommentBlock from './components/CommentBlock';
import RatingInfo from '../RatingInfo';
import CommentModal from './components/CommentModal';
import styles from './RatingComment.scss';

const RatingComment = ({
  ratings,
  averageRate,
  ratingCount,
  ratingLimit,
  eventName,
}) => {
  useStyles(styles);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation(['rating']);
  const dispatch = useDispatch();

  const onViewMoreClick = () => {
    if (eventName) {
      dispatch(
        sendGTMEvent({
          eventName,
        }),
      );
    }
    setIsModalOpen(true);
  };

  const onModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <section>
      <h2 className={styles.title}>{t('common.reviewDisplay.title')}</h2>
      <RatingInfo averageRate={averageRate} ratingCount={ratingCount} />
      <div className={styles.ratings}>
        {ratings.slice(0, ratingLimit).map(({ id, ...rating }) => (
          <CommentBlock
            key={rating.id}
            {...rating}
            className={styles.comment}
          />
        ))}
      </div>
      {ratingCount > ratingLimit && (
        <div className={styles.more}>
          <Button
            text={t('common.reviewDisplay.cta')}
            onClick={onViewMoreClick}
            ghost
          />
        </div>
      )}
      {isModalOpen && (
        <CommentModal
          onClose={onModalClose}
          averageRate={averageRate}
          ratingCount={ratingCount}
          ratings={ratings}
        />
      )}
    </section>
  );
};

RatingComment.propTypes = {
  ratings: array,
  averageRate: number,
  ratingCount: number,
  ratingLimit: number,
  eventName: string,
};

RatingComment.defaultProps = {
  ratings: [],
  averageRate: 0,
  ratingCount: 0,
  ratingLimit: 3,
  eventName: '',
};

export default RatingComment;
